/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Ln_BoatsInputs */

const es_marketplace_seo_license_row_ln_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora hasta 6 m; vela hasta 8 m (55 CV)`)
};

const gl_marketplace_seo_license_row_ln_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora ata 6 m; vela ata 8 m (55 CV)`)
};

const en_marketplace_seo_license_row_ln_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor up to 6 m; sail up to 8 m (55 HP)`)
};

/**
* | output |
* | --- |
* | "Motor up to 6 m; sail up to 8 m (55 HP)" |
*
* @param {Marketplace_Seo_License_Row_Ln_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_ln_boats = /** @type {((inputs?: Marketplace_Seo_License_Row_Ln_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Ln_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_ln_boats(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_ln_boats(inputs)
	return es_marketplace_seo_license_row_ln_boats(inputs)
});